'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toArray");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var isIpfs = require('is-ipfs');

var CID = require('cids');

var _require = require('../../utils/cid'),
    cidToString = _require.cidToString;

var _require2 = require('../utils'),
    withTimeoutOption = _require2.withTimeoutOption;
/**
 * @typedef {Object} ResolveOptions
 * @prop {string} cidBase - Multibase codec name the CID in the resolved path will be encoded with
 * @prop {boolean} [recursive=true] - Resolve until the result is an IPFS name
 *
 */

/** @typedef {(path: string, options?: ResolveOptions) => Promise<string>} Resolve */

/**
 * IPFS Resolve factory
 *
 * @param {Object} config
 * @param {IPLD} config.ipld - An instance of IPLD
 * @param {NameApi} [config.name] - An IPFS core interface name API
 * @returns {Resolve}
 */


module.exports = function (_ref) {
  var ipld = _ref.ipld,
      name = _ref.name;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _resolve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, opts) {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, resolvedPath, _path$split, _path$split2, hash, rest, cid, results, value, remainderPath, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              opts = opts || {};

              if (isIpfs.path(path)) {
                _context.next = 3;
                break;
              }

              throw new Error('invalid argument ' + path);

            case 3:
              if (!isIpfs.ipnsPath(path)) {
                _context.next = 39;
                break;
              }

              if (name) {
                _context.next = 6;
                break;
              }

              throw new Error('failed to resolve IPNS path: name API unavailable');

            case 6:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 8;
              _iterator = _asyncIterator(name.resolve(path, opts));

            case 10:
              _context.next = 12;
              return _iterator.next();

            case 12:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 16;
              return _step.value;

            case 16:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 23;
                break;
              }

              resolvedPath = _value;
              path = resolvedPath;

            case 20:
              _iteratorNormalCompletion = true;
              _context.next = 10;
              break;

            case 23:
              _context.next = 29;
              break;

            case 25:
              _context.prev = 25;
              _context.t0 = _context["catch"](8);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 29:
              _context.prev = 29;
              _context.prev = 30;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 34;
                break;
              }

              _context.next = 34;
              return _iterator.return();

            case 34:
              _context.prev = 34;

              if (!_didIteratorError) {
                _context.next = 37;
                break;
              }

              throw _iteratorError;

            case 37:
              return _context.finish(34);

            case 38:
              return _context.finish(29);

            case 39:
              _path$split = path.split('/'), _path$split2 = _toArray(_path$split), hash = _path$split2[2], rest = _path$split2.slice(3); // ['', 'ipfs', 'hash', ...path]

              cid = new CID(hash); // nothing to resolve return the input

              if (!(rest.length === 0)) {
                _context.next = 43;
                break;
              }

              return _context.abrupt("return", "/ipfs/".concat(cidToString(cid, {
                base: opts.cidBase
              })));

            case 43:
              path = rest.join('/');
              results = ipld.resolve(cid, path);
              value = cid;
              remainderPath = path;
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _context.prev = 49;
              _iterator2 = _asyncIterator(results);

            case 51:
              _context.next = 53;
              return _iterator2.next();

            case 53:
              _step2 = _context.sent;
              _iteratorNormalCompletion2 = _step2.done;
              _context.next = 57;
              return _step2.value;

            case 57:
              _value2 = _context.sent;

              if (_iteratorNormalCompletion2) {
                _context.next = 64;
                break;
              }

              result = _value2;

              if (CID.isCID(result.value)) {
                value = result.value;
                remainderPath = result.remainderPath;
              }

            case 61:
              _iteratorNormalCompletion2 = true;
              _context.next = 51;
              break;

            case 64:
              _context.next = 70;
              break;

            case 66:
              _context.prev = 66;
              _context.t1 = _context["catch"](49);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t1;

            case 70:
              _context.prev = 70;
              _context.prev = 71;

              if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                _context.next = 75;
                break;
              }

              _context.next = 75;
              return _iterator2.return();

            case 75:
              _context.prev = 75;

              if (!_didIteratorError2) {
                _context.next = 78;
                break;
              }

              throw _iteratorError2;

            case 78:
              return _context.finish(75);

            case 79:
              return _context.finish(70);

            case 80:
              return _context.abrupt("return", "/ipfs/".concat(cidToString(value, {
                base: opts.cidBase
              })).concat(remainderPath ? '/' + remainderPath : ''));

            case 81:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 25, 29, 39], [30,, 34, 38], [49, 66, 70, 80], [71,, 75, 79]]);
    }));

    function resolve(_x, _x2) {
      return _resolve.apply(this, arguments);
    }

    return resolve;
  }());
};